import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Input } from "@/components/ui/input";
import { toast } from "@/components/ui/sonner";

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const { setAdmin, config } = useApp();
  const logoUrl = config?.branding?.logo_url;
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/admin/login", form);
      localStorage.setItem("lostdc_admin_token", data.token);
      setAdmin(data.admin);
      toast.success(`Welcome back, ${data.admin.name}`);
      navigate("/admin");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#003366] flex items-center justify-center px-5 relative overflow-hidden">
      <div className="absolute inset-0 chakra-watermark opacity-40" />
      <form onSubmit={submit} data-testid="admin-login-form" className="relative bg-white rounded-2xl p-8 md:p-10 w-full max-w-sm shadow-2xl">
        <div className="tricolor-bar h-1 rounded-full mb-8" />
        <div className="w-14 h-14 rounded-xl bg-[#0b1f3a] flex items-center justify-center mb-5 overflow-hidden">
          {logoUrl ? <img src={logoUrl} alt="LostDrkc" className="w-full h-full object-contain p-1.5" /> : <ShieldCheck className="w-6 h-6 text-[#FF9933]" />}
        </div>
        <h1 className="text-2xl font-black font-heading text-slate-900 tracking-tight">Admin Console</h1>
        <p className="text-sm text-slate-500 mt-1 mb-6">LostDrkc Competition Control</p>
        <label className="text-xs font-bold tracking-[0.15em] uppercase text-slate-500">Email</label>
        <Input data-testid="admin-email" type="email" className="mt-1.5 mb-4" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required autoComplete="username" />
        <label className="text-xs font-bold tracking-[0.15em] uppercase text-slate-500">Password</label>
        <Input data-testid="admin-password" type="password" className="mt-1.5" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required autoComplete="current-password" />
        <button type="submit" disabled={busy} data-testid="admin-login-submit" className="mt-6 w-full py-3 rounded-lg bg-[#003366] text-white font-bold hover:bg-[#00284f] transition-colors disabled:opacity-50">
          {busy ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
